'use strict';

var startOfDay = require('date-fns/startOfDay');
var parsers = require('../parsers.cjs');

function _interopDefault (e) { return e && e.__esModule ? e.default : e; }

var startOfDay__default = /*#__PURE__*/_interopDefault(startOfDay);

const dateToStartOfDayISODateTimePart = (date) => {
  return parsers.dateToISODateTimePart(startOfDay__default(date));
};

exports.dateToStartOfDayISODateTimePart = dateToStartOfDayISODateTimePart;
//# sourceMappingURL=dateToStartOfDayISODateTimePart.cjs.map
